// autoplay vdo in pdp
document.addEventListener("DOMContentLoaded", function () {
    setTimeout(function () {
      var playIcons = document.querySelectorAll('.deferred-media__poster-button.motion-reduce');
      var video = document.querySelectorAll('.deferred-media video');
      playIcons?.forEach(function(icon, index) {
        icon.click();
        video[index].play();
      });
    }, 1000);
  });

// details toggle
$('.product-metafields-blocks .list-unstyled.details').hide().first().show();
$('.product-metafields-blocks .bg_title').click(function () {
  const $c = $(this).next('.list-unstyled.details');
  $('.list-unstyled.details').not($c).slideUp();
  $c.stop(true, true).slideToggle();
  $('.toggle-icon-svg').not($(this).find('.toggle-icon-svg')).removeClass('rotate');
  $(this).find('.toggle-icon-svg').toggleClass('rotate');
});

// price breakup update
  function updatePriceBreakup() {
    const oldHTML = document.querySelector('.list-unstyled.price_breakup.details');
    const oldDeliveryHTML = document.querySelector('.estimated_delivery_date');
    if (!oldHTML) return;
    fetch(`${window.location.href}?section_id=product-metafields-blocks`)
      .then(response => response.text())
      .then(result => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(result, 'text/html');
        const newHTML = doc.querySelector('.list-unstyled.price_breakup.details');
        const newDeliveryHTML = doc.querySelector('.estimated_delivery_date');
        if (newHTML) {
          oldHTML.innerHTML = newHTML.innerHTML;
        }
        if (newDeliveryHTML) {
          oldDeliveryHTML.innerHTML = newDeliveryHTML.innerHTML;
        }
      })
      .catch(error => console.error('Price breakup update failed:', error));
  }
  document.addEventListener('change', function (e) {
    if (e.target && e.target.classList.contains('custom_select_updates')) {
      setTimeout(updatePriceBreakup, 1500);
    }
  });

// setTimeout(function() {
//  document.getElementById("save_shipping_information").checked = true;
// },2000);

//custom size on PDP 
document.addEventListener('DOMContentLoaded', function () {
  const form = document.querySelector("form[action='/cart/add']");
  const atcButton = document.querySelector(".product-form__submit");
  const selectSize = document.getElementById("main_custom-size");
  if (!form || !selectSize || !atcButton) return;
  let hiddenInput = document.createElement("input");
  hiddenInput.type = "hidden";
  hiddenInput.name = "properties[Size]";
  form.appendChild(hiddenInput);

  selectSize.addEventListener("change", function () {
    hiddenInput.value = this.value;
  });
  atcButton.addEventListener("click", function (e) {
    e.preventDefault();
    if (!selectSize.value) {
      alert("Please select a size.");
      return;
    }
    hiddenInput.value = selectSize.value;
    form.submit();
  });
});
// document.addEventListener("DOMContentLoaded", function () {

//   const selectSize = document.getElementById("main_custom-size");

//   if (!selectSize) {
//     console.log("Size select not found");
//     return;
//   }

//   document.addEventListener("submit", function (e) {

//     const form = e.target;

//     if (!form.matches('[data-type="add-to-cart-form"]')) return;

//     console.log("Intercept submit");

//     let input = form.querySelector('input[name="properties[Size]"]');

//     if (!input) {
//       input = document.createElement("input");
//       input.type = "hidden";
//       input.name = "properties[Size]";
//       form.appendChild(input);
//     }

//     input.value = selectSize.value;

//     console.log("Size added =", input.value);

//   }, true);

// });

// filter availability values
// document.addEventListener("DOMContentLoaded", function () {
//   const filters = document.querySelectorAll(
//     '[id^="Details-filter.p.m.custom.availability"] .facet-checkbox__text-label'
//   );

//   filters.forEach(label => {
//     const value = label.textContent.trim();

//     if (value === "1") {
//       label.textContent = "In stock";
//     } else if (value === "0") {
//       label.textContent = "Out of stock";
//     }
//   });
// });

//menu open on hover
document.querySelectorAll('.menu-item-has-children').forEach(item => {
  const details = item.querySelector('details');
  if (!details) return;
  item.addEventListener('mouseenter', () => {
    details.setAttribute('open', 'true');
  });
  item.addEventListener('mouseleave', () => {
    details.removeAttribute('open');
  });
});

// custom collection grid
function handleCustomLayout() {
  if ($(window).width() > 990) {
    if (!$('.main-block-2').length) {
      $('.block-2').wrapAll('<div class="main-block-2"></div>');
    }

  } else {
    $('.block-2').unwrap('.main-block-2');
    $('.block-1, .block-2').children().unwrap();
  }
}
handleCustomLayout();
$(window).on('resize', function () {
  handleCustomLayout();
});



document.addEventListener("DOMContentLoaded", function () {
  const sliders = [
    '#Slider-template--18521398050914__video_list_XAzgFa',
    '#Slider-template--18521398050914__collection_list_b39YB9'
  ];

  sliders.forEach((selector) => {
    const slider = document.querySelector(selector);

    if (slider) {
      let scrollAmount = 0;
      const cardWidth = slider.querySelector('li')?.offsetWidth || 300;

      setInterval(() => {
        scrollAmount += cardWidth;

        if (scrollAmount >= slider.scrollWidth - slider.clientWidth) {
          scrollAmount = 0;
        }

        slider.scrollTo({
          left: scrollAmount,
          behavior: "smooth"
        });
      }, 3000);
    }
  });
});


